/* Chaotic-style homepage behaviours (cz-*) */
(function () {
  function initSlider(root) {
    if (root.dataset.czReady) return;
    root.dataset.czReady = '1';
    var track = root.querySelector('.cz-track');
    if (!track) return;
    var bar = root.querySelector('.cz-progress span');
    var prev = root.querySelectorAll('[data-cz-prev]');
    var next = root.querySelectorAll('[data-cz-next]');
    function step() {
      var item = track.children[0];
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / (item.offsetWidth + gap)));
      return per * (item.offsetWidth + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      if (bar) {
        bar.style.width = Math.min(100, ratio * 100) + '%';
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (pos * (1 / Math.max(ratio, 0.0001) - 1) * 100) + '%)';
      }
      prev.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      next.forEach(function (b) { b.disabled = track.scrollLeft >= max - 2; });
    }
    prev.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initSlideshow(root) {
    if (root.dataset.czReady) return;
    root.dataset.czReady = '1';
    var track = root.querySelector('.cz-slideshow__track');
    var slides = track ? track.children : [];
    var n = slides.length;
    if (n < 2) return;
    var dots = root.querySelectorAll('.cz-slideshow__dots button');
    var i = 0, timer = null, delay = (parseInt(root.dataset.delay, 10) || 5) * 1000;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function play() { if (root.dataset.autoplay === 'true') { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); } }
    root.querySelector('[data-cz-prev]').addEventListener('click', function () { go(i - 1); play(); });
    root.querySelector('[data-cz-next]').addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    });
    play();
  }

  function initTabs(root) {
    if (root.dataset.czReady) return;
    root.dataset.czReady = '1';
    var tabs = root.querySelectorAll('[data-cz-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-cz-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
        root.querySelectorAll('[data-cz-panel]').forEach(function (p) {
          var on = p.getAttribute('data-cz-panel') === id;
          p.classList.toggle('is-active', on);
          if (on) p.querySelectorAll('[data-cz-slider]').forEach(function (s) { s.dataset.czReady = ''; initSlider(s); });
        });
        root.querySelectorAll('[data-cz-link]').forEach(function (a) {
          a.classList.toggle('is-active', a.getAttribute('data-cz-link') === id);
        });
      });
    });
  }

  function initStack(root) {
    if (root.dataset.czReady) return;
    root.dataset.czReady = '1';
    var stack = root.querySelector('.cz-stack');
    if (!stack) return;
    function rotate(dir) {
      if (dir > 0) stack.appendChild(stack.firstElementChild);
      else stack.insertBefore(stack.lastElementChild, stack.firstElementChild);
    }
    root.querySelectorAll('[data-cz-next]').forEach(function (b) { b.addEventListener('click', function () { rotate(1); }); });
    root.querySelectorAll('[data-cz-prev]').forEach(function (b) { b.addEventListener('click', function () { rotate(-1); }); });
    stack.addEventListener('click', function (e) {
      var card = e.target.closest('.cz-stack__card');
      if (!card || card === stack.firstElementChild) return;
      while (stack.firstElementChild !== card) rotate(1);
    });
    if (root.dataset.autoplay === 'true') setInterval(function () { if (!root.matches(':hover')) rotate(1); }, 4000);
  }

  function initPopup(root) {
    if (root.dataset.czReady) return;
    root.dataset.czReady = '1';
    var key = 'czNewsletterSeen';
    var design = root.hasAttribute('data-design-mode');
    var seen = false;
    try { seen = !!localStorage.getItem(key); } catch (e) {}
    function close() { root.classList.remove('is-open'); try { localStorage.setItem(key, '1'); } catch (e) {} }
    root.querySelectorAll('[data-cz-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (root.hasAttribute('data-posted')) { root.classList.add('is-open'); return; }
    if (design || seen) return;
    setTimeout(function () { root.classList.add('is-open'); }, (parseInt(root.dataset.delay, 10) || 6) * 1000);
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-cz-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-cz-slideshow]').forEach(initSlideshow);
    scope.querySelectorAll('[data-cz-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-cz-stackwrap]').forEach(initStack);
    scope.querySelectorAll('[data-cz-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
